import { render } from "./PurchasesReportView.vue?vue&type=template&id=7b519ff0"
import script from "./PurchasesReportView.vue?vue&type=script&lang=js"
export * from "./PurchasesReportView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__